// extracted by mini-css-extract-plugin
export default {"textBoxContainer":"TextBox_textBoxContainer__pGGCm","textInput":"TextBox_textInput__0lHz8","charCount":"TextBox_charCount__IsLtO"};